import selectorReducerFor, { selectorInitialState, SelectorState } from '../redux/selector/reducerFor'
import { API_POLICY_PREFIX, API_POLICY_RESOURCE_NAME, APIPolicyAction } from './actions'
import { DetailedPolicy } from '../../remote-api/models'

export type APIPolicySelectorState = SelectorState<DetailedPolicy>

export const apiPolicySelectorInitialState = {...selectorInitialState}

export const apiPolicySelectorReducer = (origin?: string) => {
  const apiPolicyReducerForOrigin = selectorReducerFor<DetailedPolicy>(API_POLICY_RESOURCE_NAME, API_POLICY_PREFIX, origin)
  return function reducer(state: APIPolicySelectorState = apiPolicySelectorInitialState, action: APIPolicyAction): APIPolicySelectorState {
    return {
      ...state,
      ...apiPolicyReducerForOrigin(state, action)
    }
  }
}
